import { z } from 'zod'
import { validateWithZodSchema } from '../../core/utils/utilities.ts'

/**
 * Lean row returned by the `/deals/mobile-list` endpoint (the mobile deals browse list).
 * Only what a mobile row renders: id / name / company / currency, the stage tag (id +
 * label + colour), and the raw Val / raise / commitment figures (formatted client-side via
 * `deals__currency` + globalConfigs.currencies, same as the grid). The backend
 * `view__deals_mobile_list` RPC skips the grid's embedded tasks/contacts arrays.
 * `.passthrough()` stays tolerant of extra keys.
 */
export const DealMobileListRecordSchema = z
  .object({
    deals__id: z.string(),
    deals__name: z.string().nullish(),
    deals__currency: z.string().nullish(),
    accounts__name: z.string().nullish(),
    pipeline_deals__stage: z.string().nullish(),
    pipeline_deals__stage__label: z.string().nullish(),
    pipeline_stages__colour: z.string().nullish(),
    rounds__raise_amount: z.number().nullish(),
    prog__commitment_amount: z.number().nullish(),
    prog__valuation: z.number().nullish(),
    prog__valuation_type: z.string().nullish()
  })
  .passthrough()

export type DealMobileListRecord = z.infer<typeof DealMobileListRecordSchema>

export function validateDealMobileListRecord(
  data: unknown,
  options?: { isArray?: boolean }
): DealMobileListRecord | DealMobileListRecord[] {
  return validateWithZodSchema(DealMobileListRecordSchema, data, 'deal mobile list record', options) as
    | DealMobileListRecord
    | DealMobileListRecord[]
}
